<div class="backDark" [ngClass]=" {'backWhite':darkmode === false}" fxLayout="column" fxFlex="100%" *ngIf="loaded===1">

    <!--------------------------------------------------------------- HEADER MENU -->


    <div class="menu border-b" fxLayoutAlign=" center" [ngClass]=" {'border-b2':darkmode === false}">

        <!-- elementos de lado izquierdo del menu -->
        <div fxLayout="row" fxFlex="100%" fxLayoutAlign=" center">

            <!-- boton ir a mi curso -->
            <div class="backDiv border-r" fxLayout="column" fxLayoutAlign="center center"
                [ngClass]=" {'border-r2':darkmode === false}">
                <mat-icon routerLink="/est/mi-curso/{{id}}" class="mg10 linkIcon gray-7 ft22 "
                    [ngClass]=" {'gray-9':darkmode === false}"> arrow_back
                </mat-icon>
            </div>

            <h6 *ngIf="claseActual" fxShow="true" fxShow.lt-lg="false" class="mg10 gray-3 ft500 ft16"
                [ngClass]=" {'gray-9':darkmode === false}">
                {{claseActual.numero}}.
                {{claseActual.titulo}}
            </h6>
        </div>

        <!-- elementos de lado izquierdo del menu -->
        <div fxLayout="row">
            <div>
                <mat-slide-toggle [(ngModel)]="darkmode" class="pd0 mg0"></mat-slide-toggle>
            </div>


            <button (click)="anterior()" type="button" class="mgl10 darkButton ft12"
                [ngClass]=" {'grayButton gray-8':darkmode === false}">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon ft16" [ngClass]=" {'grayButton gray-8':darkmode === false}"> arrow_back
                    </mat-icon>
                    &nbsp;
                    <span class="gray-1 ft12" [ngClass]=" {'grayButton gray-8':darkmode === false}">Anterior</span>
                </div>
            </button>

            <button (click)="siguiente()" type="button" class="mgl10 darkButton backGray9 ft12 mgr10"
                [ngClass]=" {'grayButton gray-8':darkmode === false}">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <span class="gray-1 ft12" [ngClass]=" {'gray-8':darkmode === false}">Siguiente</span>
                    &nbsp;
                    <mat-icon class=" linkIcon ft16" [ngClass]=" {'grayButton gray-8':darkmode === false}">
                        arrow_forward </mat-icon>
                </div>
            </button>
        </div>
    </div>

    <div class="menuMobile border-b" [ngClass]=" {'border-b2':darkmode === false}" fxLayoutAlign=" center"
        fxShow="false" fxShow.lt-lg="true">
        <h6 *ngIf="claseActual" class="mg10 gray-3 ft500 ft16" [ngClass]=" {'gray-9':darkmode === false}">
            {{claseActual.numero}}.
            {{claseActual.titulo}}
        </h6>
    </div>

    <!--------------------------------------------------------------- CONTENEDOR DE PANELES -->


    <div class="fw"  fxLayout="row" fxLayoutAlign="space-between">


        <!--------------------------------------------------------------- CONTENEDOR IZQUIERDO - BARRA -->

        <div fxLayout="column" fxShow="true" fxShow.lt-lg="false" class="containerIzq border-r">

            <div class="panelSesiones " [ngClass]=" {'border-r2':darkmode === false}">

                <!-- Barra de progreso -->
                <div class="mgt08 mgb10" fxLayout="row" fxLayoutAlign="space-between center"
                    class="pdt08 pdl10 pdr10 pdb10">
                    <span class="ft13 ft500 gray-6 " [ngClass]=" {'gray-8':darkmode === false}" fxFlex="40%">Progreso
                        {{progresoTotal}} %</span>
                    <mat-progress-bar mode="determinate" [value]="progresoTotal" fxFlex="65%"></mat-progress-bar>
                </div>

                <!-- Listado de sesiones -->
                <div>
                    <div *ngFor="let item of clases;  let i=index" (click)="clickClases(i)"
                        fxLayoutAlign="space-between" fxLayoutGap="1rem"
                        class="pdt08 pdb08 containerModulo cursorPointer"
                        [ngClass]=" {'sesionActiva':i === idxActual && darkmode === true, 'sesionActiva2':i === idxActual && darkmode === false, 'containerModulo2':i != idxActual && darkmode === false}">

                        <div>
                            <div *ngIf="item.completado === 1" fxLayout="row" fxLayoutAlign="center center"
                                class="iconBorderS-Complete" [ngClass]=" {'iconBorderS-Complete2':darkmode === false}">
                                <mat-icon *ngIf="item.tipo === 'video'" class="blue-2 ft15 linkIcon"
                                    [ngClass]=" {'blue-4':darkmode === false}">play_arrow </mat-icon>
                                <mat-icon *ngIf="item.tipo === 'lectura' || item.tipo === 'pdf'"
                                    class="blue-2 ft15 linkIcon" [ngClass]=" {'blue-4':darkmode === false}">short_text
                                </mat-icon>
                            </div>
                            <div *ngIf="item.completado === 0" fxLayout="row" fxLayoutAlign="center center"
                                class="iconBorderS">
                                <mat-icon *ngIf="item.tipo === 'video'" class="gray-6 ft15 linkIcon">play_arrow
                                </mat-icon>
                                <mat-icon *ngIf="item.tipo === 'lectura' || item.tipo === 'pdf' "
                                    class="gray-6 ft15 linkIcon">short_text
                                </mat-icon>
                            </div>
                        </div>

                        <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="space-between" fxFlex="100%">
                            <span class="ft11 ft400 gray-5 lineHeight100" fxFlex="100%"
                                [ngClass]=" {'gray-8':darkmode === false, 'ft500':i === idxActual}">{{item.numero}}.
                                {{item.titulo}}
                            </span>
                            <span class="ft10 light-title-color">{{item.duracion}}:00</span>
                        </div>
                    </div>
                    <div routerLink="/est/cuestionario/{{id}}" fxLayout="row"
                        *ngIf="progresoTotal>=90 ; else examenInactivo"
                        class="pdt08 pdb08 containerModulo cursorPointer">
                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderS">
                            <mat-icon class="gray-6 ft15 linkIcon">menu </mat-icon>
                        </div>
                        <div class="mgl10">
                            <span class="ft11 ft400 gray-5 lineHeight100" [ngClass]=" {'gray-8':darkmode === false}"
                                [ngClass]=" {'gray-8':darkmode === false}">Examen
                            </span>
                        </div>
                    </div>
                    <ng-template #examenInactivo>
                        <div *ngIf="progresoTotal != 100" fxLayout="row" class="pdt08 pdb08 containerModulo"
                            matTooltip="Una vez completadas todas las sesiones podras presentar el examen">
                            <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderS">
                                <mat-icon class="gray-6 ft15 linkIcon">menu </mat-icon>
                            </div>
                            <div class="mgl10">
                                <span class="ft11 ft400 gray-8 lineHeight100" [ngClass]=" {'gray-8':darkmode === false}"
                                    [ngClass]=" {'gray-3':darkmode === false}">Examen
                                </span>
                            </div>
                        </div>

                    </ng-template>


                </div>
            </div>
        </div>

        <!--------------------------------------------------------------- CONTENEDOR DERECHO -->

        <div *ssrExclude  fxLayout="column" fxFlex="100%">


            <!--------------------------------------------------------------- VIDEO -->
            <div *ngIf="claseActual.tipo == 'video'">
                <iframe *ssrExclude  ngClass.gt-sm="videoContainer" ngClass.lt-md="videoContainerMobile" id="myvideo" [src]="safeUrl"
                    (load)="initPlayer()" frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen>
                </iframe>
                <!-- <button (click)="initPlayer()">Iniciar Player</button> -->
            </div>
            <div class="innerHTML pd20 disable-text-selection" [ngClass]=" {'innerHTML2':darkmode === false}"
                *ngIf="claseActual.tipo == 'lectura'">
                <div [innerHTML]="claseActual.HTMLcontent"></div>
                <button (click)="completar(idxActual)" class="darkButton ft11 ft500"
                    [ngClass]=" {'grayButton gray-9':darkmode === false}">Marcar como completada</button>
            </div>

            <!-- PDF viewer -->
            <div class="disable-text-selection noPrint" *ngIf="claseActual.tipo == 'pdf'">

                <div *ssrExclude oncontextmenu="return false;">
                    <pdf-viewer *ssrExclude  ngClass.gt-sm="pdfRenderer" ngClass.lt-lg="pdfRenderer2" [src]="claseActual.HTMLcontent" [original-size]='false' [show-all]="true"
                        [stick-to-page]="true" [render-text]='false' [autoresize]="true" ></pdf-viewer>
                </div>

                <button (click)="completar(idxActual)" class="darkButton ft11 ft500 mgl20 mg10"
                    [ngClass]=" {'grayButton gray-9':darkmode === false}">Marcar como completada</button>
                    <div ngClass.gt-sm="pdfContainer" ngClass.lt-lg="pdfContainer2"></div>
            </div>

            <!--------------------------------------------------------------- DESCRIPCION DE SESION Y MATERIAL DESCARGABLE -->

            <div fxLayout="row" fxLayoutAlign=" center" class="border-b" [ngClass]=" {'border-b2':darkmode === false}">
                <div class="pdt08 pdb08 pdl10 pdr10" fxLayout="row" fxLayoutAlign=" center" (click)="selectTab1()"
                    [ngClass]=" {'selectedTab':selectedTab == 1 && darkmode == true , 'selectedTab2':selectedTab == 1 && darkmode == false} ">
                    <span class="ft500 ft13 gray-6" [ngClass]=" {'gray-8':darkmode === false}">Descripción de la
                        sesión</span>
                </div>

                <div class="pdt08 pdb08 pdl10 pdr10" (click)="selectTab2()"
                    [ngClass]=" {'selectedTab':selectedTab == 2, 'selectedTab2':selectedTab == 2 && darkmode == false}">
                    <div fxLayout="row" fxLayoutAlign=" center">
                        <span class="ft500 ft13 gray-6" [ngClass]=" {'gray-8':darkmode === false}">Material
                            descargable</span>
                        <div *ngIf="claseActual.archivos.length>=1" class="mgl05 badge" fxLayout="column"
                            fxLayoutAlign="center center">
                            <span class="ft11 gray-1 ft500">{{claseActual.archivos.length}}</span>
                        </div>
                    </div>
                </div>
                <div class="pdt08 pdb08 pdl10 pdr10" (click)="selectTab3()"
                    [ngClass]=" {'selectedTab':selectedTab == 3, 'selectedTab2':selectedTab == 3 && darkmode == false}">
                    <div fxLayout="row" fxLayoutAlign=" center">
                        <span class="ft500 ft13 gray-6" [ngClass]=" {'gray-8':darkmode === false}">Preguntas al
                            instructor</span>
                    </div>
                </div>
            </div>
            <div>
                <div class="pd10 contenidoSesion border-b" [ngClass]=" {'border-b2':darkmode === false}">
                    <div>
                        <p class="gray-6" *ngIf="selectedTab===1" [ngClass]=" {'gray-8':darkmode === false}">
                            {{claseActual.descripcion}}
                        </p>
                    </div>
                    <div *ngIf="selectedTab===2">
                        <div fxLayout="row wrap" fxLayoutAlign="center center" class="files pdl20 pdr20">
                            <div *ngFor="let item of claseActual.archivos;  let i=index">
                                <div class="mgt08 mgb08 mgr10">
                                    <a href="" class=" file">
                                        <span class="ft12 gray-7 ft500"> {{i}}. </span>
                                        <span class="ft400 gray-6"><a [href]=item.url
                                                target="_blank">{{item.nombre}}</a></span>
                                        <span class="mgl05 ft10 gray-8"> {{item.size / 1000}} KB</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedTab===3" fxLayout="column" fxLayoutAlign="center center" class="fh fw">
                        <p class="gray-6 centertext" [ngClass]=" {'gray-8':darkmode === false}">
                            Si tiene alguna duda o comentario sobre el contenido del curso contacte al instructor a
                            través del siguiente correo:
                        </p>
                        <a href="mailto:{{instructor.email}}" target="_blank">
                            <span class="chip backBlue2 cursorPointer">
                                {{instructor.email}}
                            </span>
                        </a>

                    </div>
                </div>
            </div>

        </div>

    </div>
</div>

<div *ngIf="loaded===0" class="backDark">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>